export default __webpack_public_path__ + "img/caonDSAX.2ddb2303.svg";